// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as vue from 'vue'; // for typing, don't delete
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import { SnackBarTypeEnum } from '@/stores/types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as sbTypes from '@/stores/types'; // For typing, don't delete

function defaultState() {
  return {
    snackbarData: undefined,
  };
}

export const useAppStore = defineStore('appStore', () => {
  function $reset() {
    const state = defaultState();
    snackbarState.value = state.snackbarData;
  }

  /** @type {vue.Ref<sbTypes.SnackbarOptions | undefined>} */
  const snackbarState = ref(undefined);

  /** @type  {vue.ComputedRef<sbTypes.SnackbarOptions | undefined>} */
  const snackbarData = computed(() => {
    if (!snackbarState.value) {
      return undefined;
    }

    return {
      message: snackbarState.value.message,
      type: snackbarState.value.type,
      duration: snackbarState.value.duration,
    };
  });

  /**
   * @param {object} payload
   * @param {string} payload.message
   * @param {string} payload.messageType
   * @param {number} [payload.duration]
   */
  function showAlert(payload) {
    const { message, messageType, duration } = payload;

    let timeout = duration;

    if (!timeout) {
      timeout = messageType === SnackBarTypeEnum.Error ? 120000 : 5000;
    }

    snackbarState.value = {
      message,
      type: messageType,
      duration: timeout,
    };
  }

  /**
   *
   * @param {string} message
   * @param {number | undefined} [duration]
   */
  function showErrorAlert(message, duration) {
    showAlert({
      message,
      messageType: SnackBarTypeEnum.Error,
      duration,
    });
  }

  /**
   *
   * @param {string} message
   * @param {number | undefined} [duration]
   */
  function showInfoAlert(message, duration) {
    showAlert({
      message,
      messageType: SnackBarTypeEnum.Info,
      duration,
    });
  }

  /**
   *
   * @param {string} message
   * @param {number | undefined} [duration]
   */
  function showSuccessAlert(message, duration) {
    showAlert({
      message,
      messageType: SnackBarTypeEnum.Success,
      duration,
    });
  }

  return {
    $reset,

    snackbarData,

    showAlert,

    showInfoAlert,
    showErrorAlert,
    showSuccessAlert,
  };
});
